import { render, staticRenderFns } from "./photoUploader.vue?vue&type=template&id=1793006c&scoped=true"
import script from "./photoUploader.vue?vue&type=script&lang=js"
export * from "./photoUploader.vue?vue&type=script&lang=js"
import style0 from "./photoUploader.vue?vue&type=style&index=0&id=1793006c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1793006c",
  null
  
)

export default component.exports